import ReactGA from 'react-ga4';

export class AnalyticsService {
  private static instance: AnalyticsService;
  private isInitialized = false;

  private constructor() {}

  public static getInstance(): AnalyticsService {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  public init(measurementId: string): void {
    if (!this.isInitialized) {
      ReactGA.initialize(measurementId);
      this.isInitialized = true;
      console.log('GA4 initialized');
    }
  }

  public pageView(path: string): void {
    if (this.isInitialized) {
      ReactGA.send({ hitType: 'pageview', page: path });
    }
  }

  public event(category: string, action: string, label?: string): void {
    if (this.isInitialized) {
      ReactGA.event({
        category,
        action,
        label
      });
    }
  }

  public timing(category: string, variable: string, value: number): void {
    if (this.isInitialized) {
      ReactGA.event({
        category,
        action: 'timing',
        value,
        label: variable
      });
    }
  }

  // Application-specific events
  public trackContactFormSubmit(success: boolean, timeToSubmit?: number): void {
    this.event(
      'Contact',
      'form_submit',
      success ? 'success' : 'failure'
    );

    if (timeToSubmit) {
      this.timing('Contact', 'form_completion_time', timeToSubmit);
    }
  }

  public trackServiceView(serviceName: string): void {
    this.event(
      'Service',
      'view',
      serviceName
    );
  }

  public trackAppointmentBooked(serviceType: string): void {
    this.event(
      'Appointment',
      'booked',
      serviceType
    );
  }
} 